import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import PropTypes from 'prop-types';
const gap = '30px';
const GridContainer = styled.div`
  label: JMT-General-Grid;
  display: flex;
  flex-wrap: wrap;
  gap: ${gap};
  @media (max-width: 992px) {
    gap: 12.5px 25px;
  }
`;
const GridItem = styled.div`
  margin-bottom: 10px;
  ${p => {
  let size = 33.3;

  if (['full', '1'].includes(p.size)) {
    size = 100;
  } else if (['one-third', '1/3'].includes(p.size)) {
    size = 33.3;
  } else if (['two-third', '2/3'].includes(p.size)) {
    size = 66.7;
  } else if (['half', '1/2'].includes(p.size)) {
    size = 50;
  } else if (['one-quarter', '1/4'].includes(p.size)) {
    size = 25;
  } else if (['three-quarter', '3/4'].includes(p.size)) {
    size = 75;
  }

  return css`
      flex-basis: calc(${size < 100 ? `${size}% - ${gap}` : `${size}%`});
      @media (max-width: 992px) {
        flex-basis: calc(${size <= 50 ? `50% - ${gap}` : `${size}%`});
      }
      @media (max-width: 595px) {
        flex-basis: 100%;
      }
    `;
}}
`;
export const Grid = ({
  children
}) => React.createElement(GridContainer, null, children.map(child => React.createElement(GridItem, {
  key: child.key,
  size: child.props.size
}, child)));
Grid.propTypes = {
  children: PropTypes.node.isRequired
};